import React from "react";
import HeroManual from "./HeroManual";
import HeroAutomatic from "./HeroAutomatic";

/**
 * Top-level Hero dispatcher.
 *
 * Routes to the manual column-grid renderer (HeroManual) when manual_layout
 * is true (or when no hero_mode is set), and to HeroAutomatic for
 * mode-based rendering.
 */
const Hero = ({ item, containerWidth }) => {
  const data = item || {};
  const isManual = data.manual_layout !== false;

  if (isManual || !data.hero_mode) {
    return <HeroManual item={item} containerWidth={containerWidth} />;
  }

  return <HeroAutomatic item={item} containerWidth={containerWidth} />;
};

export default Hero;
